export default __webpack_public_path__ + "static/media/AsteroidDust.774d42a5.png";